module.exports = __webpack_public_path__ + "img/profile_credential_007.3692b411.png";